<template>
  <svg
    v-if="name === 'facebook'"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Facebook</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.67 4.36426H5.33C4.59773 4.3697 4.00544 4.96199 4 5.69426V27.0343C4.00544 27.7665 4.59773 28.3588 5.33 28.3643H16.82V19.0843H13.7V15.4543H16.82V12.7843C16.82 9.68426 18.71 7.99426 21.49 7.99426C22.42 7.99426 23.35 7.99426 24.28 8.13426V11.3643H22.37C20.86 11.3643 20.57 12.0843 20.57 13.1343V15.4443H24.17L23.7 19.0743H20.57V28.3643H26.67C27.4023 28.3588 27.9946 27.7665 28 27.0343V5.69426C27.9946 4.96199 27.4023 4.3697 26.67 4.36426Z"
      fill="#40513B"
    />
  </svg>
  <svg
    v-else-if="name === 'linkedin'"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>LinkedIn</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.21 4.36429H5.79C4.82225 4.35847 4.02717 5.12691 4 6.09429V26.5643C4.02186 27.534 4.8201 28.3055 5.79 28.2943H26.21C27.1799 28.3055 27.9781 27.534 28 26.5643V6.09429C27.9728 5.12691 27.1777 4.35847 26.21 4.36429ZM11.11 24.7743H7.59V13.3643H11.11V24.7743ZM9.39 11.7743C8.26602 11.7746 7.34715 10.8779 7.32 9.75429C7.30022 9.19946 7.51195 8.66138 7.90452 8.26881C8.29709 7.87624 8.83517 7.66451 9.39 7.68429C10.4748 7.75983 11.3162 8.66186 11.3162 9.74929C11.3162 10.8367 10.4748 11.7388 9.39 11.8143V11.7743ZM24.48 24.7043H21V19.1243C21 17.7943 21 16.0643 19.14 16.0643C17.28 16.0643 17 17.5243 17 18.9943V24.6443H13.44V13.3643H16.76V14.8643H16.83C17.5237 13.6596 18.8312 12.9422 20.22 13.0043C23.81 13.0043 24.48 15.4043 24.48 18.4543V24.7043Z"
      fill="#40513B"
    />
  </svg>
  <svg
    v-else-if="name === 'twitter'"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Twitter</title>
    <path
      d="M18.2837 14.5278L27.2123 4.36426H25.0972L17.3413 13.1873L11.1513 4.36426H4.01001L13.3726 17.7075L4.01001 28.3643H6.12505L14.3102 19.0448L20.8488 28.3643H27.99M6.88841 5.92616H10.1377L25.0956 26.8791H21.8455"
      fill="#40513B"
    />
  </svg>
  <svg
    v-else-if="name === 'x'"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>X</title>
    <path
      d="M18.2837 14.5278L27.2123 4.36426H25.0972L17.3413 13.1873L11.1513 4.36426H4.01001L13.3726 17.7075L4.01001 28.3643H6.12505L14.3102 19.0448L20.8488 28.3643H27.99M6.88841 5.92616H10.1377L25.0956 26.8791H21.8455"
      fill="#40513B"
    />
  </svg>
  <svg
    v-else-if="name === 'youtube'"
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Youtube</title>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.41 9.62445C29.0858 8.41974 28.1447 7.47872 26.94 7.15445C24.76 6.56445 16 6.56445 16 6.56445C16 6.56445 7.24002 6.56445 5.06002 7.15445C3.85531 7.47872 2.91429 8.41974 2.59002 9.62445C2.18297 11.8477 1.98543 14.1043 2.00002 16.3645C1.98543 18.6246 2.18297 20.8812 2.59002 23.1045C2.91429 24.3092 3.85531 25.2502 5.06002 25.5745C7.24002 26.1645 16 26.1645 16 26.1645C16 26.1645 24.76 26.1645 26.94 25.5745C28.1447 25.2502 29.0858 24.3092 29.41 23.1045C29.8171 20.8812 30.0146 18.6246 30 16.3645C30.0146 14.1043 29.8171 11.8477 29.41 9.62445ZM13.2 20.5645V12.1645L20.47 16.3645L13.2 20.5645Z"
      fill="#40513B"
    />
  </svg>
</template>
<script>
export default {
  name: "SocialMediaIcons",
  props: {
    name: String,
  },
};
</script>
